// Constants and seed data for Herb Brittner's Smokehouse application
import { Location, OrderStatus } from './types';

// Available locations
export const LOCATIONS: Location[] = ['Cranberry', 'Zelienople'];

// Order statuses
export const STATUSES: OrderStatus[] = ['Pending', 'Website Submitted', 'Done', 'Picked Up', 'Cancelled'];

// Timezone for all timestamps (Eastern Time - New York)
export const TIMEZONE = 'America/New_York';
